module.exports = __webpack_public_path__ + "media/images/flags/32/Malaysia-96e0e752a637b632bbf2c21b4f259b17.png";